import { gql } from "graphql-request";
const MODELER_PROPS_FRAGMENT = gql`
  fragment ModelerPropsFragment on Modeler {
    id
    createdBy
    createdAt
    updatedAt
    updatedBy
    description
    title
    thumbnailImage
    thumbnailImageUrl
    solver
    editable
    creator
    timeSinceCreated
  }
`;
export const GET_MODELERS_BY_FILTER_QUERY = gql`
  query getModelersListByFilter(
    $filter: ModelerFilterInput!
    $from: Int
    $size: Int
    $context: RequestContextInput!
  ) {
    listModelers(filter: $filter, from: $from, size: $size, context: $context) {
      items {
        ...ModelerPropsFragment
      }
      total
    }
  }
  ${MODELER_PROPS_FRAGMENT}
`;
export const GET_MODELER_BY_ID_QUERY = gql`
  query getModelerById(
    $id: FirstLevelIDInput!
    $context: RequestContextInput!
  ) {
    getModeler(id: $id, context: $context) {
      id
      createdBy
      description
      title
      templateId
      thumbnailImage
      access
      solver
      report
      generatedReportId
      inputGroups {
        label
        description
        inputItems {
          name
          description
          inputType
          minValue
          maxValue
          step
          optionsList
          label
          defaultValue
        }
      }
      modelRuns {
        items {
          id
          runName
          runStatus
          runNotes
          createdAt
          createdBy
        }
      }
    }
  }
`;
export const CREATE_NEW_MODELER_MUTATION = gql`
  mutation createModeler(
    $modeler: CreateModelerInput!
    $requester_id: String!
  ) {
    createModeler(input: $modeler, requester_id: $requester_id) {
      id
      templateId
      createdBy
      description
      title
      thumbnailImage
      access
      inputGroups {
        label
        description
        inputItems {
          name
          description
          inputType
          minValue
          maxValue
          step
          optionsList
          label
          defaultValue
        }
      }
    }
  }
`;

export const CLONE_MODELER_MUTATION = gql`
  mutation cloneModeler(
    $input: CloneModelerInput!
    $context: RequestContextInput!
  ) {
    cloneModeler(input: $input, context: $context){
      id
      templateId
      createdBy
      description
      title
      thumbnailImage
      access
      inputGroups {
        label
        description
        inputItems {
          name
          description
          inputType
          minValue
          maxValue
          step
          optionsList
          label
          defaultValue
        }
      }
    }      
  }
`;

export const DELETE_MODELER_MUTATION = gql`
  mutation deleteModeler(
    $input: FirstLevelIDInput!
    $context: RequestContextInput!
  ) {
    deleteModeler(input: $input, context: $context) {
      id
    }
  }
`

export const UPDATE_MODELER_MUTATION = gql`
  mutation updateModeler(
    $input: UpdateModelerInput!
    $condition: FirstLevelIDInput!
    $context: RequestContextInput!
  ) {
    updateModeler(
      input: $input
      condition: $condition
      context: $context
    ) {
      description
      title
      report
    }
  }
`;

export const EXECUTE_REPORT_PIPELINE_MUTATION = gql`
  mutation executeReportPipeline(
    $input: ExecuteReportPipelineInput!
    $context: RequestContextInput!
  ) {
    executeReportPipeline(input: $input, context: $context) {
      generatedReportId
    }
  }
`;
